import { gql } from "@apollo/client";

export const CREATE_SALARY_ADVANCE = gql`
  mutation CreateSalaryAdvance($input: createSalaryAdvanceInput) {
    createSalaryAdvance(input: $input) {
      Id
    }
  }
`;

export const UPDATE_SALARY_ADVANCE = gql`
  mutation UpdateSalaryAdvance($input: updateSalaryAdvanceInput) {
    updateSalaryAdvance(input: $input)
  }
`;

export const CANCEL_SALARY_ADVANCE = gql`
  mutation CancelSalaryAdvance($input: cancelSalaryAdvanceInput) {
    cancelSalaryAdvance(input: $input)
  }
`;

export const GET_SALARY_ADVANCE_BY_USERID = gql`
  query GetSalaryAdvanceByUserId($userId: String) {
    getSalaryAdvanceByUserId(userId: $userId) {
      Id
      userId
      salaryAdvanceAmount
      installmentMonths
      reason
      createdOn
      status
      reportTo
      l2Report
      l1Report
      l2Status
      l1Status
    }
  }
`;

export const GET_SALARY_ADVANCE_BY_ID = gql`
  query GetSalaryAdvanceById($Id: Int) {
    getSalaryAdvanceById(Id: $Id) {
      Id
      userId
      salaryAdvanceAmount
      installmentMonths
      reason
      createdOn
      status
      reportTo
      employeeDetails {
        firstName
        lastName
      }
      l1Report
      l1Status
      l2Report
      l2Status
      deductionStarts
      totalDeductedAmount
    }
  }
`;

export const GET_SALARY_ADVANCE_BY_REPORTTO = gql`
  query GetSalaryAdvanceByReportTo($reportTo: String) {
    getSalaryAdvanceByReportTo(reportTo: $reportTo) {
      Id
      userId
      salaryAdvanceAmount
      installmentMonths
      reason
      createdOn
      status
      reportTo
      l2Report
      l1Report
      l2Status
      l1Status
      employeeDetails {
        firstName
        lastName
      }
    }
  }
`;

export const GET_ALL_SALARY_ADVANCE = gql`
  query GetAllSalaryAdvance {
    getAllSalaryAdvance {
      Id
      userId
      salaryAdvanceAmount
      installmentMonths
      reason
      createdOn
      status
      reportTo
      employeeDetails {
        firstName
        lastName
        imageUrl
      }
      l1Report
      l1Status
      l2Report
      l2Status
    }
  }
`;
